import React from "react";

// Texte libre : une ligne `## Titre` -> section numérotée ; blocs séparés par une
// ligne vide -> paragraphes. Mise en page éditoriale douce (pages légales & custom).
export default function RichBody({ text }) {
  if (!text) return null;
  const blocks = String(text)
    .split(/\n\s*\n/)
    .map((b) => b.trim())
    .filter(Boolean);
  let n = 0;
  return (
    <div className="mt-14 space-y-9">
      {blocks.map((block, i) => {
        if (block.startsWith("## ")) {
          n += 1;
          return (
            <div
              key={i}
              data-testid={`legal-section-${n}`}
              className={`flex items-baseline gap-4 ${n > 1 ? "pt-7 border-t border-white/[0.07]" : ""}`}
            >
              <span className="font-mono-hs text-[11px] text-[#BC5D2E] tracking-[0.2em] shrink-0 tabular-nums pt-1">
                {String(n).padStart(2, "0")}
              </span>
              <h2 className="font-clash text-[22px] sm:text-2xl tracking-tight text-[#F5F5F0] leading-snug">
                {block.slice(3).trim()}
              </h2>
            </div>
          );
        }
        return (
          <p
            key={i}
            className="text-[15px] sm:text-base text-[#B5B5AD] leading-[1.85] whitespace-pre-line sm:pl-9"
          >
            {block}
          </p>
        );
      })}
    </div>
  );
}
